import { createAsyncThunk } from '@reduxjs/toolkit';
import { getLoggedInUserInfo } from 'src/models/appConfig/selectors';
import { getState } from 'src/store';
import { setError, setLoading, setResults } from './slice';

export const fetchTestResults = createAsyncThunk(
  'visualTesting/fetchResults',
  async (prId: string, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await fetch(`/frontend/api/visualTests/${prId}`);
      if (!response.ok) throw new Error('Failed to fetch test results');
      const data = await response.json();
      dispatch(setResults({ prId, results: data?.data }));
      dispatch(setLoading(false));
    } catch (err: unknown) {
      const errorMessage =
        err instanceof Error ? err.message : 'An error occurred';
      dispatch(setError(errorMessage));
      dispatch(setLoading(false));
    }
  },
);

export const updateTestStatus = createAsyncThunk(
  'visualTesting/updateStatus',
  async (
    {
      prId,
      testName,
      status,
      commitHash,
    }: {
      prId: string;
      testName: string;
      status: 'approved' | 'rejected';
      commitHash: string;
    },
    { dispatch },
  ) => {
    try {
      dispatch(setLoading(true));
      const userId = getLoggedInUserInfo(getState())?.email;

      await fetch(`/frontend/api/visualTests/${prId}/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          testName,
          status,
          userId,
          commitHash,
        }),
      });

      const response = await fetch(`/frontend/api/visualTests/${prId}`);
      const data = await response.json();
      dispatch(setResults({ prId, results: data?.data }));
    } catch (err: unknown) {
      const errorMessage =
        err instanceof Error ? err.message : 'Failed to update test status';
      dispatch(setError(errorMessage));
    } finally {
      dispatch(setLoading(false));
    }
  },
);

const onActivate = ({ dispatch, props }) => {
  dispatch(fetchTestResults(props.prId));
};

export default { onActivate };
